import React, { useEffect } from "react";
import axios from "axios";
import { Secondary } from "ui-components/Buttons";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GoogleIcon from '../../assets/google_icon.png'
import Cookies from "js-cookie"
import { jwtDecode } from 'jwt-decode'
import { LoginSocialGoogle, LoginSocialLinkedin } from 'reactjs-social-login';
import { LoginViaEmail } from "api";
import { Cookie } from "@mui/icons-material";
import { checkForDomain, setTokenForAuthorization, setUserType } from "utils/index";
const STATE = 'random_string_for_security';

const GoogleLogin = () => {
  const loginMethod = "google";
  const providerCookies = Cookies.get("provider")
  const currentIP = window.location.host;
  const currentLOcation = window.location.pathname;
  const [searchParams, setSearchParams] = useSearchParams()
  const theme = useTheme()
  const navigate = useNavigate()
  const [provider, setProvider] = React.useState('');
  const [profile, setProfile] = React.useState(null);
  const { mutateAsync: loginViaEmailAsync, status: LoginViaEmailStatus, error: LoginViaEmailError, isLoading, data: loginViaEmailResponse } = LoginViaEmail();

  const onLoginStart = () => {
    // console.log('Login started');
  };

  const onResolve = async ({ provider, data }) => {
    Cookies.remove('userDetails');
    setProvider(provider);
    setProfile(data);
    // const decodedData = jwtDecode(data?.access_token)
    fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${data?.access_token}`).then(response => response.json())
      .then(async (data) => {
        // Cookies.set("userDetails", JSON.stringify({ first_name: data?.given_name, last_name: data?.family_name }))
        // setLoginMethod("google");
        await loginViaEmailAsync({
          "email": data?.email,
          ...(searchParams.get("utm_source") ? { utm_source: searchParams.get("utm_source") } : {}),
          ...(searchParams.get("utm_campaign") ? { utm_campaign: searchParams.get("utm_campaign") } : {}),
          "devices": {
            "device_token": `${Math.random() * 10}`,
            "device_type": "web"
          },
          "last_login_ip": `${currentIP}`,
          "auth_provider": "google"
        }, {
          onSuccess: (verifyResponse) => {
            const response = verifyResponse?.data?.data;
            // console.log(verifyResponse, "ref")
            Cookies.set("email", data?.email);
            Cookies.set("provider", "google")
            if (currentIP?.includes("localhost")) {
              if (response?.collaborator_data?.connected_id) {
                Cookies.set("X-INV-ID", response?.collaborator_data?.connected_id);
              }
              response?.userData?.token && setTokenForAuthorization(response?.userData?.token);
              // response?.token && setUserType("investor");
            }
            // response?.token && setUserType("investor");
            // Session to be same for current users:
            response?.userData?.token && setTokenForAuthorization(response?.userData?.token, checkForDomain());
            Cookies.set("step", Number(response?.step));
            // console.log(response, "response")
            // Boolean(response?.permissions) && Cookies.set("permissions", JSON.stringify(response?.permissions));
            const pathname = Cookies.get("pathname") || "/";

            const hasCollaborator = Boolean(response?.collaborator_data?.connected_id);
            const hasInvestorId = Boolean(response?.investor_id);
            const claimedProfile = response?.claim_profile === true;
            const notClaimedAndNoInvestor = response?.claim_profile === false && !hasInvestorId;

            if (hasCollaborator) {
              Cookies.set("X-INV-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
              Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
              navigate(pathname, { replace: true });
              Cookies.remove("pathname");
            } else if (claimedProfile && hasInvestorId) {
              Cookies.set("X-INV-TEMP-ID", response?.investor_id, { domain: checkForDomain() });
              Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
              navigate("/activate-profile", { replace: true });
            } else if (notClaimedAndNoInvestor) {
              navigate("/onboarding", { replace: true });
            } else {
              Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
              setTimeout(() => {
                navigate(response?.is_profile_completed ? pathname : "/onboarding", { replace: true });
                Cookies.remove("pathname");
              }, 10);
            }
          },
          onError: () => {
            // setEmailError(true);
          }
        })
      })

  };

  const onReject = (err) => {
    console.error('Login failed', err);
  };

  return (
    <LoginSocialGoogle
      client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      client_secret={process.env.REACT_APP_GOOGLE_CLIENT_SECRET}
      redirect_uri={origin}
      scope="openid profile email"
      onLoginStart={onLoginStart}
      onResolve={onResolve}
      onReject={onReject}
      typeResponse={'accessToken'}
      isOnlyGetToken
    >
      <Secondary
        sx={{ border: `1px solid #E0E0E6`, borderRadius: '10px', height: '54px', marginBottom: { xs: "0rem", sm: 0 } }}
        fullWidth
      >
        {isLoading && loginMethod == "google" ? <CircularProgress sx={{ color: "black", marginInline: 'auto' }} size={'1.4rem'} /> : <Grid
          display={"flex"}
          gap={1}
          flexDirection={"row"}
          alignItems={"center"}
        >
          <img src={GoogleIcon} width={24} height={24} />
          <Typography
            variant="caption"
            sx={{ textTransform: "none", fontWeight: 500, fontSize: '1rem', color: '#344054' }}
          >
            Continue with Google
          </Typography>
        </Grid>}
      </Secondary>
    </LoginSocialGoogle>
  );
};

export default GoogleLogin;